export const USE_NEW_SIGN_IN_PROCESS = true;